import React, { useEffect } from 'react';
import { useTournament } from 'context/TournamentContext';
import {
  Wrap,
  Title,
  SubTitle,
  RewardSpinner,
  RewardStatus,
  RewardSubStatus,
} from '../EndPage/styled';

const POLL_INTERVAL_MS = 5000;

const FinalizingView: React.FC = () => {
  const { tournamentDetails, refreshTournamentState } = useTournament();

  useEffect(() => {
    if (!refreshTournamentState) return undefined;
    const id = setInterval(() => {
      refreshTournamentState().catch(() => {});
    }, POLL_INTERVAL_MS);
    return () => clearInterval(id);
  }, [refreshTournamentState]);

  const rawData: any = tournamentDetails?.data;
  const attributes = rawData?.attributes ?? rawData?.data ?? rawData ?? {};
  const tournamentName: string = attributes?.name ?? 'Tournament';
  const endAt: string | null | undefined = attributes?.end_at ?? attributes?.endDate;
  const endAtLabel = endAt ? new Date(endAt).toLocaleString() : null;

  return (
    <Wrap className="wrapModalEnd">
      <SubTitle>Tournament</SubTitle>
      <Title>{tournamentName}</Title>
      <RewardSpinner />
      <RewardStatus>Finalizing tournament results…</RewardStatus>
      <RewardSubStatus>
        {endAtLabel
          ? `Trading ended at ${endAtLabel}. Final ranking and payouts are being calculated.`
          : 'Final ranking and payouts are being calculated.'}
      </RewardSubStatus>
    </Wrap>
  );
};

export default FinalizingView;
